import logo from './logo.svg';
import './App.css';
import Header from './components/Header.tsx'
import Home from './pages/Home.tsx'

function App() {
  return (
    <div className="App">
      <Header />
      <Home />
    </div>
  );
}

export default App;
